export default function DeleteRiskConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  riskDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete($event) {
    loaderService.showViewLoader = true;
    return riskDataService.deleteRisk(vm.risk.customerRiskId)
      .then(() => {
        alerts.success(`The risk "${vm.risk.name}" was successfully deleted.`);
        if (vm.asset) {
          if (vm.showSyncAsset === true && vm.assetType) {
            $rootScope.$broadcast('refreshAssets', { assetType: vm.assetType });
          } else {
            $rootScope.$broadcast('refreshAssetRisks', { asset: vm.asset });
          }
        } else if (vm.riskType) {
          $rootScope.$broadcast('refreshRiskType', { riskType: vm.riskType });
        } else {
          $rootScope.$broadcast('refreshRisks');
        }
        _closeDialog($event);
      }).catch(() => {
        alerts.error('An error occurred while deleting the risk.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }
  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.riskAdmin.deleteRiskConfirmDialog);
  }
}

DeleteRiskConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'riskDataService',
  'loaderService',
  'ssDialogService'
];
